
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { get } from "lodash";

import { UserPermissions, FeaturesList, VueBootstrapField } from "@/store/types";
import NavHeader from "@/components/NavHeader.vue";
import { ExternalMenuLink } from "@/store/external-menu-link/types";
import DeleteExternalMenuLinkModal from "@/components/external-menu-link/DeleteExternalMenuLinkModal.vue";
import ExternalMenuLinkModal from "@/components/external-menu-link/ExternalMenuLinkModal.vue";

const ExternalMenuLinkStore = namespace("externalMenuLink");

@Component({
	components: {
		"nav-header": NavHeader,
		"external-menu-link-modal": ExternalMenuLinkModal,
		"delete-external-menu-link-modal": DeleteExternalMenuLinkModal
	}
})
export default class ExternalMenuLinkSetup extends Vue {
	@Getter("getFeaturesList") featuresList: FeaturesList;
	@Getter("getPermissions") permissions: UserPermissions;

	@ExternalMenuLinkStore.Action loadExternalMenuLinks: () => Promise<void>;
	@ExternalMenuLinkStore.Getter("getExternalMenuLink") externalMenuLinks: ExternalMenuLink[];

	// bootstrap table data
	private fields: VueBootstrapField[] = [
		{ key: "title", label: "Title", sortable: true },
		{ key: "link", label: "URL", sortable: true },
		{ key: "text", label: "Display Text", sortable: true },
		{ key: "isNewTab", label: "Open in new tab?", sortable: false },
		{ key: "iconName", label: "Icon Name", sortable: false },
		{ key: "iconFile", label: "Icon", sortable: false },
		{ key: "actions", label: "Actions", sortable: false }
	];

	private filterSearch: string = "";
	private selectedExternalMenuLink: ExternalMenuLink = null;
	private showDeleteModal: boolean = false;
	private showEditModal: boolean = false;

	// Should move to an icon helper file along with  getIconImage()
	private imageEncodeType: Map<string, string> = new Map([
		["/", "jpg"],
		["i", "png"],
		["R", "gif"]
	]);

	public get canViewMenuLinkSetup() {
		return (
			get(this.featuresList, ["NavMenu", "ExternalMenuLinks"]) &&
			(this.permissions.isAdmin ||
				this.permissions.canViewExternalMenuLinks ||
				this.permissions.canEditExternalMenuLinks)
		);
	}

	public get canEditMenuLinkSetup() {
		return this.permissions.isAdmin || this.permissions.canEditExternalMenuLinks;
	}

	public async mounted() {
		await this.loadExternalMenuLinks();
	}

	private async toggleIsNewTab(externalMenuLink: ExternalMenuLink) {
		externalMenuLink.isNewTab = !externalMenuLink.isNewTab;
		//await this.updateExternalMenuLink(externalMenuLink);
	}

	private setDeleteExternalMenuLink(externalMenuLink: ExternalMenuLink) {
		this.selectedExternalMenuLink = externalMenuLink;
		this.showDeleteModal = !this.showDeleteModal;
	}

	private setSelectedExternalMenuLink(externalMenuLink: ExternalMenuLink) {
		this.selectedExternalMenuLink = externalMenuLink;
		this.showEditModal = !this.showEditModal;
	}

	private getIconImage(menuLink: ExternalMenuLink): string {
		if (!menuLink.iconFile || menuLink.iconFile == "null") return;
		let identifier = menuLink.iconFile.charAt(0);
		return `data:image/${this.imageEncodeType.get(identifier)};base64,` + menuLink.iconFile;
	}

	@Watch("showEditModal")
	private onModalChange(): void {}
}
